import { withRouter } from 'react-router';

import GraphicImpression from '../components/GraphicImpression';

export default withRouter(GraphicImpression); // Force re-add on location change
